// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width:767px){.da-article-teaser__image img{max-height:200px}}.da-article-teaser__title{font-size:1.125rem;font-variation-settings:\"wght\" 400;font-weight:400;line-height:1.5rem;margin:18px 0 10px}.da-article-teaser__title a{color:#2d2c2d}.da-article-teaser__leadtext{color:#adadad;font-size:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
